import React from "react";
import { SpaceProps } from "styled-system";
import { ContactPreferencesConfig } from "../../../../../types/ContactConfig";
import { Flex } from "../../../../Flex";
import { Span } from "../../../../Span";
import { IconPopupTip } from "../../../../IconPopupTip";
import { ContactDetails } from "../../../../../types/ContactDetailsValues";
import { NewContactPreference } from "../NewContactPreference";

interface Props {
  idPrefix: string;
  namePrefix: string;
  contactPreferencesConfig: ContactPreferencesConfig[];
  contactDetails: ContactDetails;
}

export const NewContactPreferences: React.FC<Props & SpaceProps> = ({
  idPrefix,
  namePrefix,
  contactPreferencesConfig,
  contactDetails,
}) => {
  return (
    <Flex id={idPrefix} flexDirection="column">
      {contactPreferencesConfig.length > 0 && (
        <Flex
          flexDirection="row"
          mb={3}
          justifyContent={[
            "space-between",
            "space-between",
            "space-between",
            "flex-start",
          ]}
        >
          <Span fontSize={2} lineHeight={2} mr={3}>
            {"Select contact preferences"}
          </Span>
          <IconPopupTip icon="help" ml={["auto", "auto", 3]}>
            Select the preferred communication channel to receive job updates
          </IconPopupTip>
        </Flex>
      )}

      {contactPreferencesConfig.map((contactPreferenceConfig, index) => (
        <NewContactPreference
          key={`${idPrefix}.contactPreferencesConfig[${index}]`}
          idPrefix={`${idPrefix}.contactPreferencesConfig[${index}]`}
          namePrefix={`${namePrefix}`}
          contactPreferenceConfig={contactPreferenceConfig}
          contact={contactDetails}
        />
      ))}
    </Flex>
  );
};
